import React from 'react'

function FormInput({
    label,
    required = false,
    type = 'text',
    name,
    value,
    onChange,
    error,
    disabled = false,
    maxLength = '',
}) {
    return (
        <div>

            <label className="text-sm mb-1 block">

                {label}

                {required && (
                    <span className="text-red-500 text-sm">
                        {' '}*
                    </span>
                )}

            </label>

            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                maxLength={maxLength}
                className={`
                    input
                    input-bordered
                    input-md
                    w-full
                    ${error ? 'border-error' : ''}
                `}
            />

            {error && (
                <p className="text-red-500 text-xs mt-1">
                    {error}
                </p>
            )}

        </div>
    )
}

export default FormInput